export default __webpack_public_path__ + "static/media/add-cookbook.66f3504b.svg";